var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"toggle-selection-icon",class:[( _obj = {}, _obj[("le-icon-" + _vm.icon)] = true, _obj['primary'] =  _vm.usePrimary, _obj['active'] =  _vm.isActive, _obj )],domProps:{"innerHTML":_vm._s(require(("!html-loader!@assets/images/icons/" + _vm.icon + ".svg")))}})}
var staticRenderFns = []
export { render, staticRenderFns }